// ** Reducers Imports
import layout from "./layout";
import navbar from "./navbar";
import login from "./login";
import companies from "./companies";
import projects from "./projects";
import workers from "./workers";
import settings from "./settings";
import quantomState from "./quantomState";
import assignmentTypes from "./assignmentTypes";

const rootReducer = {
  navbar,
  layout,
  login,
  companies,
  projects,
  workers,
  settings,
  quantomState,
  assignmentTypes,
};

export default rootReducer;
